import Tabs from '@components/v2/ui/Tabs/Tabs';
import { Children, ReactNode, isValidElement } from 'react';
import { ObjectTab } from './components/ObjectTab';
import { useObjectTabs } from './hooks/useObjectTabs';

interface ObjectTabsProps {
  children: ReactNode;
}

const DeclarativeObjectTabs = ({ children }: ObjectTabsProps) => {
  const { items, activeTab, handleSelect } = useObjectTabs({ children });

  return <Tabs items={items} selectedId={activeTab} onSelect={handleSelect} />;
};

export function ObjectTabs({ children }: ObjectTabsProps) {
  const hasDeclarativeTabs = Children.toArray(children).some(
    (child) => isValidElement(child) && child.type === ObjectTab,
  );

  if (!hasDeclarativeTabs) {
    return <>{children}</>;
  }

  return <DeclarativeObjectTabs>{children}</DeclarativeObjectTabs>;
}
